export enum TransportationTypeId {
  DRIVE = 1,
  FLY = 2,
}
